/*
 * @Author: Dzy
 * @Date: 2022-07-15 10:13:01
 * @LastEditors: xiangwenheng
 * @LastEditTime: 2023-03-27 17:18:04
 * @Description: 路由配置信息，按照菜单结构进行配置
 */
import { createRouter, createWebHistory } from 'vue-router'
import login from '@/views/login/index.vue'
import { clearStorage } from '@tools'

const anonymous = true // 登录鉴权元信息
const requiresAuth = true // 身份验证元信息
const keepAlive = true // keep-alive 缓存

// TODO:后续改造路由结构
import ADMIN_Routes from './admin'
import K12_Routes from './k12'
import NF_Routes from './nf'
import GX_Routes from './gx'
import Single_Routes from './single'
import { message } from 'ant-design-vue'

const v2routes = [
  /**
   * @description: 登录页面
   */
  {
    path: '/',
    name: 'login',
    component: login,
    meta: { anonymous },
    props: true
  },
  /**
   * @description: 个人中心
   */
  {
    path: '/myInfo',
    name: 'myInfo',
    component: () => import('/src/views/myInfo'),
    breadcrumbName: '个人中心',
    meta: { anonymous, requiresAuth },
    children: [
      {
        /**
         * @description: 个人中心
         */
        path: 'base',
        component: () => import('/src/views/myInfo/base.vue'),
        breadcrumbName: '编辑个人资料',
        meta: { requiresAuth }
      },
      {
        /**
         * @description: 个人中心 -> 编辑个人资料
         */
        path: 'editUser',
        component: () => import('/src/views/myInfo/editUserData.vue'),
        breadcrumbName: '编辑个人资料',
        meta: { requiresAuth }
      },
      {
        /**
         * @description: 个人中心 -> 编辑身份信息
         */
        path: 'editAccount',
        component: () => import('/src/views/myInfo/editAccountData.vue'),
        props: true,
        breadcrumbName: '编辑个人领域信息',
        meta: { requiresAuth }
      }
    ]
  },
  {
    path: '/menuManagement',
    name: 'menuManagement',
    component: () => import('/src/views/menuManagement/index.vue'),
    meta: { requiresAuth }
  },
  {
    /**
     * @description: 高校-体育测试——组织测试——成绩查询成绩单
     */
    path: '/scoreReport',
    name: 'scoreReport',
    component: () => import('/src/views/gx/sportTest/organizeTest/scoreSearch/report.vue'),
    meta: { requiresAuth }
  },
  {
    /**
     * @description: k12-体育测试——组织测试——成绩查询成绩单
     */
    path: '/scoreReportK12',
    name: 'scoreReportK12',
    component: () => import('/src/views/k12/sportTest/organizeTest/scoreSearch/report.vue'),
    meta: { requiresAuth }
  },
  /**
   * @description: 第三方中转页
   */
  {
    path: '/thirdManagement',
    name: 'thirdManagement',
    component: () => import('/src/views/thirdPath/transferPage/index.vue'),
    meta: { anonymous }
  },
]

export const routes = v2routes

const vueRoute = createRouter({ history: createWebHistory('/busi'), routes })

// 初始构建标识
let initializeBuildIdentity = true
const whiteList = ['/', '/myInfo/base', '/myInfo/editUser', '/myInfo/editAccount', '/thirdManagement']

vueRoute.beforeEach((to) => {
  const authBusi = JSON.parse(localStorage.getItem('authBusi'))

  if (whiteList.includes(to.path)) {
    initializeBuildIdentity = true // 进入登录页面，需要初始化
  } else {
    if (authBusi && authBusi.uinfo.currentTypePath) {
      if (initializeBuildIdentity) {
        vueRoute.options.routes.push(Single_Routes)
        vueRoute.addRoute(Single_Routes)

        if (authBusi.uinfo.currentTypePath == '/admin') {
          vueRoute.options.routes.push(ADMIN_Routes)
          vueRoute.addRoute(ADMIN_Routes)
        } else if (authBusi.uinfo.currentTypePath == '/k12') {
          vueRoute.options.routes.push(K12_Routes)
          vueRoute.addRoute(K12_Routes)
        } else if (authBusi.uinfo.currentTypePath == '/gx') {
          vueRoute.options.routes.push(GX_Routes)
          vueRoute.addRoute(GX_Routes)
        } else if (authBusi.uinfo.currentTypePath == '/nf') {
          vueRoute.options.routes.push(NF_Routes)
          vueRoute.addRoute(NF_Routes)
        }
        initializeBuildIdentity = false
        vueRoute.push({ ...to, replace: true })
      }
    } else {
      if (!whiteList.includes(to.path)) {
        clearStorage()

        message.warn('未登录，请登录')
        vueRoute.push({ path: '/' })
      }
    }
  }

  localStorage.setItem('toCurrentRouteBusi', to.path)
})
export default vueRoute
